

<template>
	<transition name="plopp" mode="out-in">	

		<div class="intro d-flex align-items-center justify-content-center mt-md-0 p-7 p-md-5" v-move-to="`body`" v-if="loadedData.content">

			<div class="content p-10 p-md-15 text-center" v-touchy:clickoutside="onClickClose">

				<a @click="onClickClose" class="close p-2">
					<i class="fal fa-times"></i>
				</a>

				<div class="text mb-10" v-html="loadedData.content"></div>

				<a class="btn d-inline-flex align-items-center" @click="onClickGreet">
					<i class="fas fa-caret-circle-right mr-3"></i> Begrüßungsfilm
				</a>
				<a class="btn d-inline-flex align-items-center" @click="onClickClose">
					<i class="fas fa-walking mr-3"></i> Erkunden
				</a>

			</div>
		</div>
	</transition>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'
import { ApiService } from '@/services/api.service'

export default {
	store,
	data: () => {
		return {
			loadedData: {},
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
	},

	mounted() {
		this.loadIntro();
	},

	methods: {
		loadIntro() {
			ApiService.get(this.presets.intro).then(({data}) => {
				this.loadedData = data || {};
			});
		},
		onClickClose( $event ) {
			this.$emit('close-clicked')
		},
		onClickGreet() {
			EventBus.$emit('hotspot-clicked', {link:this.presets.greetingLink} );
		}
	}

}
</script>


<style scoped lang="scss">

	a {
		cursor: pointer;
	}

	.intro {

		box-shadow: 0 0 8px rgba(#000, 0.3);
		font-family: $font-condensed;
		font-size: 1rem;
		color: #555;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
		@include position( absolute, 0 0 0 0, 4000 );
		
		@media ($min-device-width-lg) {
			overflow-y: visible;
		}

	}

	a {
		font-family: $font-sans;
		font-size: 1.5rem;
		letter-spacing: 0.08em;
		color: #016b9e;
		font-weight: 700;
		text-transform: uppercase;
		i {
			font-size: 2.2rem;
			margin-top: -1px;
		}
	}

	.content {
		background: #fff;
		position: relative;
		@media ($min-device-width-md) {
			width: 80%;
			max-width: 600px;
		}
		&:before {
			content: '';
			@include position( absolute, -10px -10px -10px -10px, -1 );
			background: rgba(#fff, 0.5);
		}
	}

	.close {
		font-size: 2.5rem;
		color: #666;
		opacity: 1;
		@include position( absolute, 10px 10px auto auto, 100 );
		@media ($min-device-width-md) {
			top: 10px;
			right: 10px;
		}
	}

</style>

<style lang="scss">
	.intro .text {
		font-family: $font-sans;
		font-size: 1.4rem;
		@media ($min-device-width-lg) {
			font-size: 1.5rem;
		}
		h1, h2 {
			text-transform: uppercase;
			letter-spacing: 0.05em;
			margin: 0;
		}
		h2 {
			color: #959396;
			font-size: 2rem;
			@media ($min-device-width-lg) {
				font-size: 2.5rem;
			}
		}
		h1 {
			color: #376083;
			font-weight: 600;
			font-size: 2.5rem;
			@media ($min-device-width-lg) {
				font-size: 3.5rem;
			}
			margin-top: -28px;
		}
		h2 {
			margin-bottom: 30px;
		}
		p {
			margin: 0 0 8px 0;
		}
	}
</style>
